import React from "react";
import { View, Text } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import { Image } from "expo-image";
import Images from "@/assets/images";
import Icons from "@/assets/icons";

const CheckItem = ({ text }: { text: string }) => (
  <View style={styles.checkItem}>
    <Icons.Check width={24} height={24} />
    <Text style={styles.checkText}>{text}</Text>
  </View>
);

export default function WelcomeSlideNew2() {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Your AI refund helper</Text>

      <View style={styles.illustrationContainer}>
        <Image
          source={Images.helpIcon}
          style={styles.backgroundIcon}
          contentFit="contain"
        />
        <View style={styles.chatBubbleLeft}>
          <Text style={styles.chatBubbleLeftText}>
            {"👋 Help me get"}{"\n"}{"a refund for..."}
          </Text>
        </View>

        <View style={styles.chatBubbleRight}>
          <Text style={styles.chatBubbleRightText}>Start AI refund</Text>
        </View>

        <View style={styles.robotContainer}>
          <Image source={Images.aiRobot} style={styles.robotImage} />
        </View>

        <View style={styles.chatBubbleBottom}>
          <Text style={styles.chatBubbleRightText}>{"Let's talk! ✨"}</Text>
        </View>
      </View>

      <View style={styles.checkList}>
        <CheckItem text="Calls customer support for you" />
        <CheckItem text="Files class action & lost money claims" />
        <CheckItem text="Monitors your spending habits" />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 36,
    color: "#161D14",
    lineHeight: 39,
    letterSpacing: -0.72,
    marginBottom: 30,
    marginTop: 30,
  },
  illustrationContainer: {
    height: 209,
    position: "relative",
    marginBottom: 55,
    marginTop: 20,
  },
  backgroundIcon: {
    position: "absolute",
    width: "100%",
    height: "100%",
    left: -15,
    top: 15,
  },
  chatBubbleLeft: {
    position: "absolute",
    left: 0,
    top: 5,
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    paddingHorizontal: 16,
    paddingVertical: 10,
    shadowColor: "#CCCCCC",
    shadowOffset: { width: 0, height: 5 },
    shadowOpacity: 0.5,
    shadowRadius: 3,
    elevation: 10,
    transform: [{ rotate: "14deg" }],
  },
  chatBubbleLeftText: {
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 14,
    color: "#0F9129",
    lineHeight: 20,
  },
  chatBubbleRight: {
    position: "absolute",
    right: 20,
    top: -15,
    backgroundColor: "#0F9129",
    borderRadius: 17,
    paddingHorizontal: 20,
    paddingVertical: 9,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 15,
    elevation: 5,
    transform: [{ rotate: "-12deg" }],
  },
  chatBubbleRightText: {
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 14,
    color: "#FFFFFF",
    lineHeight: 20,
  },
  robotContainer: {
    alignItems: "center",
    justifyContent: "center",
    marginTop: 55,
  },
  robotImage: {
    width: 114,
    height: 114,
  },
  chatBubbleBottom: {
    position: "absolute",
    left: 48,
    bottom: 0,
    backgroundColor: "#0F9129",
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 15,
    elevation: 5,
    transform: [{ rotate: "6deg" }],
  },
  checkList: {
    gap: 12,
  },
  checkItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  checkText: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 15,
    color: "#000000",
    opacity: 0.7,
    lineHeight: 23,
    flex: 1,
  },
});
